import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export function initImageCarousel() {
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=image-carousel",
			imageCarouselBlock
		);
	}
}

export function imageCarouselBlock() {
	if (!document.querySelector(".image-carousel-swiper")) return false;

	const swiper = new Swiper(".image-carousel-swiper", {
		modules: [Navigation, Pagination, Autoplay],
		slidesPerView: 2,
		slidesPerGroup: 2,
		breakpoints: {
			// when window width is >= 769px
			769: {
				slidesPerView: 3,
				slidesPerGroup: 3,
			},
			1025: {
				slidesPerView: 4,
				slidesPerGroup: 4,
			},
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		autoplay: {
			delay: 2000,
		},
	});
}
